import React, { useState, useEffect } from 'react';
import { Backdrop } from '@mui/material';
import { useSelector } from 'react-redux';
import { VerticalContainer, VerticalContainerItems } from './PageLayoutContainers/FlexContainers';
import spinner from '../images/simple-felix-spinner_1.mp4';

export const Loading = ({ open }) => {
  const loadingTitle = useSelector((state) => state.loadingSlice.loadingTitle);
  const loadingMessage = useSelector((state) => state.loadingSlice.loadingMessage);
  const [loadingContent, setLoadingContent] = useState({
    title: loadingTitle,
    message: loadingMessage,
  });

  useEffect(() => {
    setLoadingContent({ title: loadingTitle, message: loadingMessage });
  }, [loadingTitle, loadingMessage]);

  return (
    <Backdrop
      id="LoadingScreen"
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={open}
    >
      <VerticalContainer className="loadingModalContainer" alignContent="center">
        <VerticalContainerItems style={{ alignItems: 'center', marginTop: '4rem' }}>
          <video className="loadingSpinner" loop autoPlay muted>
            <source src={spinner} type="video/mp4" />
            Sorry, your browser doesn't support HTML5 video tag.
          </video>
        </VerticalContainerItems>
        <VerticalContainerItems style={{ alignItems: 'center' }}>
          <p className="loadingText">{loadingContent.title}</p>
        </VerticalContainerItems>
        <VerticalContainerItems style={{ alignItems: 'center' }}>
          <p className="waitText">{loadingContent.message}</p>
        </VerticalContainerItems>
      </VerticalContainer>
    </Backdrop>
  );
};
